<template>
    <div>
      <van-nav-bar
        title="绑定数字货币钱包"
        left-text="返回"
        left-arrow
        onclick="window.history.go(-1)"
      />
      <van-form @submit="bindWallterCard">
          <van-row class="rowStyle">
            <van-col class="textStyle" span="24">
             <span style="font-size:16px;">添加钱包 :</span>
              <span style="color:red;">（{{walletAddressStatus}}）</span>
            </van-col>
          </van-row>
          <van-row class="rowStyle">
            <van-col class="textStyle" span="6">
             <span>平台币种 :</span> 
            </van-col>
            <van-col class="textStyle" span="8">
             <span style="align:left;">{{withdrawTypeName}}</span> 
            </van-col>
        </van-row>       
        <van-field
          left
          placeholder="请输入钱包地址"
          v-model="walletAddress"
          name="walletAddress"
          :rules="[{ required: true, message: '请填写钱包地址' }]"
        >
        <template #label>
              <span style="font-size:16px;">钱包地址 :</span>
        </template>
        </van-field>
        <div style="margin-top: 16px;">
          <van-button size="normal" type="danger" native-type="submit" block>确认</van-button>
        </div>
      </van-form>
    </div>
</template>

<script>
    export default {
      name: "DigitalCurrencyWallet",
      data(){
        return{
          withdrawTypeName:'',
          walletAddress:"",
          walletAddressStatus:""
        }
      },
      computed:{
        
      },
      methods:{
        bindWallterCard(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "bind_digital",
                token: sessionStorage.getItem("token"),
                wallet_address: that.walletAddress
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.$toast.success({
                  message:resData.msg,
                  onClose:function () {
                    that.$router.push('/member/information')
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                 that.$toast.fail(resData.msg);
              }
            });
        },
        wallterCardDetails(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "digital_info",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function(res) {
              let resData = res.data;
                if (resData.code == 1) {
                that.walletAddress = resData.data.wallet_address;
                if(that.walletAddress){
                  that.walletAddressStatus = "已设置"
                }else{
                  that.walletAddressStatus = "未设置"
                }
              } else if (res.data.code == 0 || res.data.code == -1) {
                 that.$toast.fail(resData.msg);
              }
            });
        },
        getWithdrawTypes(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "account_withbank",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function(res) {
              let resData = res.data;
              var temp = [];
              if (resData.code == 1) {
                 that.withdrawTypeName = resData.data.types[0].name;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        },
      },
      mounted:function () {
        this.wallterCardDetails();
        this.getWithdrawTypes();
      }
    }
</script>

<style scoped>
.textStyle {
  padding-top: 15px;
  font-size: 16px;
}
.rowStyle {
  padding: 10px 16px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/DigitalCurrencyWallet.vue